import { render, staticRenderFns } from "./ShareRecipeWarning.vue?vue&type=template&id=1f886ea1&"
import script from "./ShareRecipeWarning.vue?vue&type=script&lang=js&"
export * from "./ShareRecipeWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports